export default "<p>\n  alert works!\n</p>\n";